// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/component/element/CarDamageForm/WageItem/WageItem.css
// module id = 1994
// module chunks = 0